// Manual status-report context labels layered over the Schema Registry (DDF)
// `device_health_report.props.status_report_context_map`. The DDF is the source
// of truth; see statusReportContexts.js for the lookup order.
//
// CORRECTIONS win over the DDF. Only add a code here when firmware shows the
// DDF label is wrong, and raise the fix with the Schema Registry owners.
//
// GAP_FILL_BY_TYPE and GAP_FILL_FAMILIES are used only when the DDF has no entry
// for a code, so each entry stops applying on its own once the DDF publishes
// that code. They carry the labels CS saw before NDB-5022:
//   - GAP_FILL_FAMILIES: the pre-NDB-5022 ND tables (contexts.js), trimmed to
//     codes the DDF does not cover for at least one device type in the family.
//     lpd and mars stay complete because some of their types (lpd, floodlight,
//     spotlightw, jbox, hp_cam, stickup_cam_mini_ptz) have no DDF map at all.
//   - GAP_FILL_BY_TYPE: codes only the SOC per-type lookup
//     (soc_status_report_context_by_device) labels.
// There is deliberately no default family: a device type that is not listed
// here and has no DDF map shows "Unknown (context N)".
//
// Generated from the NDB-5022 audit against RingSchemaRegistryMappings
// ed4d4aa3c (2026-10-15).

export const CORRECTIONS = {
  // rfw-gt firmware enum: MARS-platform 22/23 are the E2EE result contexts. The
  // DDF copies the legacy doorbell labels (wifi_calibrated / aborted_call).
  df_doorbell_clownfish: { 22: "E2EE Success", 23: "E2EE Failure" },
  doorbell_sunray: { 22: "E2EE Success", 23: "E2EE Failure" },
  doorbell_tahoe: { 22: "E2EE Success", 23: "E2EE Failure" },
  stickup_cam_gourami: { 22: "E2EE Success", 23: "E2EE Failure" },
};

export const GAP_FILL_BY_TYPE = {
  always_home_camera: { 71: "Pre Reboot", 73: "OTA Start" },
  chime: { 16: "Oauth Failure" },
  chime_pro: { 16: "Oauth Failure" },
  chime_pro_v2: { 16: "Oauth Failure" },
  chime_v2: { 16: "Oauth Failure" },
  chime_v3: { 16: "Oauth Failure" },
  cocoa_camera_v2: { 79: "Greco Stats" },
  cocoa_camera_v3: { 79: "Greco Stats" },
  cocoa_doorbell_v3: { 79: "Greco Stats" },
  stickup_cam_longfin: { 27: "Device Health" },
};

export const GAP_FILL_FAMILIES = {
  doorbell: {
    25: "Knock Event",
    27: "Cable Connected/Disconnected",
    28: "DKAD Result",
    29: "EXT_PWR_CHANGE",
    30: "E2EE Setup Success",
    31: "E2EE Setup Failed",
    32: "Network Switched",
    128: "Country Code Changed",
  },
  chimePro: {
    14: "Stream Monitor",
    15: "Network Recovered",
    32: "Network Switched",
  },
  cam: {
    29: "EXT_PWR_CHANGE",
    30: "E2EE Setup Success",
    31: "E2EE Setup Failed",
    32: "Network Switched",
    33: "24x7 Recording",
    128: "Country Code Changed",
  },
  lpd: {
    0: "Unassigned/Unknown",
    1: "After Ding",
    2: "After Setup",
    3: "After OTA",
    4: "After Motion",
    5: "Low Battery Shutdown",
    6: "Low Temperature Shutdown",
    7: "Periodic Status Report",
    8: "Weather Alert",
    9: "Daily Report",
    10: "After Boot/Reset",
    11: "After Live View",
    12: "Battery Charge Status",
    13: "After IPerf Test",
    14: "Network Disconnected",
    15: "Network Connected",
    16: "Service Disconnected",
    17: "Service Connected",
    18: "Failed OTA",
    19: "Power On",
    20: "Pre OTA",
    21: "Power Down",
    22: "E2EE Success",
    23: "E2EE Failure",
    24: "Path Creation",
    25: "Waypoint Creation",
    26: "Flight",
    27: "Device Health",
    28: "Pre FC Upgrade",
    29: "Post FC Upgrade",
    30: "Failed FC Upgrade",
    31: "Pre ESC Upgrade",
    32: "Post ESC Upgrade",
    33: "Failed ESC Upgrade",
    34: "FC Boot",
    35: "Local Drive Failure",
    36: "BLE presence detected",
    37: "Post Streaming Session",
    38: "Post File Upload",
    39: "High Temperature Shutdown",
    40: "High Power Drive Mode",
    41: "High Power Guard Mode",
    42: "Low Power Guard Mode",
    43: "Privacy Cover Moved",
    44: "Vehicle Collision Data",
    45: "Network Changed",
    46: "Fix Acquired",
    47: "Unexpected Power Loss",
    48: "Impact",
    49: "Disturbance",
    50: "Movement Inside",
    51: "Loud Noise",
    52: "Created Clip",
    53: "Geofence Entry",
    54: "Geofence Exit",
    55: "Siren Activated",
    56: "Siren Deactivated",
    57: "Location Sharing Enabled",
    58: "Location Sharing Disabled",
    59: "Location Data Deleted",
    60: "GPS Metrics",
    61: "Calibration",
    62: "BLE Presence Lost",
    63: "Connectivity Metrics",
    64: "Drive Started",
    65: "Drive Ended",
    66: "Post P2P VOD",
    67: "Post P2P Playback",
    68: "OTA status",
    69: "Delete Local Video",
    70: "Vehicle Motion",
    71: "Pre Reboot",
    72: "Modem Reboot",
    73: "Ota Start",
    74: "Traffic Stop",
    75: "Thermal Policy",
    76: "Setup Stats",
    77: "Metrics",
    78: "Recording 24x7",
  },
  zeus: {
    28: "Pre FC Upgrade",
    29: "Post FC Upgrade",
    30: "Failed FC Upgrade",
    31: "Pre ESC Upgrade",
    32: "Post ESC Upgrade",
    33: "Failed ESC Upgrade",
    34: "FC Boot",
    61: "Calibration",
  },
  cocoa: {
    5: "Low Battery Shutdown",
    6: "Low Temperature Shutdown",
    7: "Battery Full Alert",
    8: "Weather Alert",
    14: "Network Disconnected",
    16: "Service Disconnected",
    17: "Service Connected",
    20: "Pre OTA",
    25: "Knock Event",
    27: "Cable Connected/Disconnected",
    28: "OTA Status",
    29: "Device RPC Test",
    30: "Door Unlock Test",
    31: "Setup Stats",
    32: "Network Switched",
    78: "24x7 Recording",
    128: "Country Code Change",
  },
  mars: {
    0: "Context Unknown",
    1: "Post Ding",
    2: "Post Setup",
    3: "Post OTA",
    4: "Post Motion",
    6: "Low Temp Shutdown",
    9: "Daily Report",
    10: "Boot",
    11: "Post VOD",
    12: "Charged Battery",
    13: "Post iPerf",
    15: "Network Connected",
    18: "OTA Failure",
    19: "Power On",
    21: "Status Report Send Failure",
    22: "E2EE Success",
    23: "E2EE Failure",
    24: "Pre OTA",
    28: "OTA Status",
    29: "Device RPC Test",
    30: "Door Unlock",
    31: "Setup Stats",
    32: "Privacy Shutter Status Changed",
    39: "High Temperature Shutdown",
    78: "24x7 Recording",
    128: "Country Code Change",
    129: "Battery Stress Report",
  },
};

// Device kind -> gap-fill family. A kind is the device type with any trailing
// "_vN" removed (stickup_cam_mini_v2 is listed as-is), the same rule
// contexts.js used, so versioned types keep the labels they showed before.
export const FAMILY_BY_KIND = {
  always_home_camera: "zeus",
  chime_pro: "chimePro",
  cocoa_camera: "cocoa",
  cocoa_dashcam: "cocoa",
  cocoa_doorbell: "cocoa",
  cocoa_floodlight: "cocoa",
  cocoa_spotlight: "cocoa",
  df_doorbell_clownfish: "mars",
  doorbell: "doorbell",
  doorbell_sunray: "mars",
  doorbot: "doorbell",
  floodlight: "lpd",
  floodlight_pro: "lpd",
  hp_cam: "lpd",
  jbox: "lpd",
  lpd: "lpd",
  rccs_1p_jaws: "lpd",
  spotlightw: "lpd",
  spotlightw_poe: "lpd",
  stickup_cam: "cam",
  stickup_cam_elite: "lpd",
  stickup_cam_longfin: "cam",
  stickup_cam_lunar: "cam",
  stickup_cam_mini: "lpd",
  stickup_cam_mini_ptz: "mars",
  stickup_cam_mini_v2: "lpd",
};
